"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var doctor_list_1 = require("../../utils/shopify-graphql/doctor-list");
var hooks_1 = require("preact/hooks");
var path_1 = require("../../utils/shopify/path");
var CtaButton_1 = require("../common/Btn/CtaButton");
var DoctorList = function () {
    var _a;
    var _b = (0, hooks_1.useState)(null), data = _b[0], setData = _b[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, doctor_list_1.getDoctorsData)(handle, pathType)
            .then(function (d) { return setData(d); })
            .catch(function (err) { return console.error(err); });
    }, []);
    var overrideData = {
        doctors: [
            {
                doctorName: 'Dr. Jessica Shepherd',
                doctorTitle: 'OBGYN MD, MBA, FACOG',
                image: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-doctor-shepherd-mobile.jpg?v=1726523316',
            },
            {
                doctorName: 'Dr. Roxanne Pero',
                doctorTitle: 'OBGYN MD, FACOG, FACLM, IFMCP',
                image: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-doctor-pero-mobile.jpg?v=1726523297',
            },
            {
                doctorName: 'Dr. Shahin Ghadir',
                doctorTitle: 'OBGYN MD, REI',
                image: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/OBGYN-Dr-Ghadir_1.png?v=1729198901',
            },
            {
                doctorName: 'Dr. Tyler Lloyd',
                doctorTitle: 'OBGYN MD',
                image: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-doctor-lloyd-mobile.jpg?v=1726523297',
            },
            {
                doctorName: 'Dr. Saru Bala',
                doctorTitle: 'Integrative Women’s Health ND',
                image: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-doctor-bala-mobile.jpg?v=1726523297',
            },
        ],
    };
    var newData = !data && location.pathname == '/' ? overrideData : data;
    if (!data && !newData) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    return ((0, preact_1.h)("div", { className: "doctor-list" },
        location.pathname == '/' && (0, preact_1.h)("p", { className: "doctor-list__header" }, "Meet Our Medical Team"),
        (0, preact_1.h)("div", { className: "doctor-list__group" }, (_a = newData === null || newData === void 0 ? void 0 : newData.doctors) === null || _a === void 0 ? void 0 : _a.map(function (c) { return ((0, preact_1.h)("div", { className: "doctor-list__container", key: c.doctorName },
            (0, preact_1.h)("img", { className: "doctor-list__image", src: c.image }),
            (0, preact_1.h)("p", { className: "doctor-list__name" }, c.doctorName),
            (0, preact_1.h)("p", { className: "doctor-list__title" }, c.doctorTitle))); })),
        location.pathname == '/' && ((0, preact_1.h)("div", { className: "doctor-list__cta" },
            (0, preact_1.h)(CtaButton_1.default, { backgroundColor: {
                    to: 'Left',
                    startColor: 'gogo-orange',
                    endColor: 'gogo-pale-orange',
                }, hoverColor: "gogo-orange", text: "MEET OUR DOCTORS", scrollTo: "/pages/medical-board" })))));
};
exports.default = DoctorList;
